import React, {Component} from 'react';
import {Utils} from '../common/utils';

import '../../styles/elements/svgImageLoader.css';

class SvgImageLoader extends Component {

  constructor(props) {
    super(props);
    this.image = null;
    this.svg = null;
    this.processedSvg = Utils.procesSvg(this.props.svg);
  }

  componentDidMount() {
    this.image.onload = () => {
      this.image.classList.add('svg-image-loader__image--show');
    }
  };

  render() {
    return (
      <div className={"svg-image-loader " + this.props.className}
           data-id={this.props.hasOwnProperty('dataId') ? this.props.dataId.toString() : ""}>
        {/* eslint-disable react/no-danger-with-children */}
        <div
          className="svg-image-loader__svg"
          ref={imageLoadedElem => this.svg = imageLoadedElem}
          dangerouslySetInnerHTML={{__html: this.processedSvg}} >
        </div>
        {/* eslint-enable react/no-danger-with-children */}
        <img
          className="svg-image-loader__image"
          ref={imageLoadedElem => this.image = imageLoadedElem}
          src={this.props.image}
          alt={this.props.hasOwnProperty('alt') ? this.props.alt : ""}/>
      </div>
    )
  }

}

export default SvgImageLoader;


// WEBPACK FOOTER //
// ./src/js/elements/SvgImageLoader.js